<template>
    <v-app>
        <AppBar v-if="!$store.state.desktop"/>
        <Navbar v-else/>
        <v-main>
            <router-view/>
        </v-main>
    </v-app>
</template>
<script>
    import Navbar from "./components/Navbar";
    import AppBar from "./components/AppBar";
    import { mapMutations } from 'vuex';

    export default {
        components: {AppBar, Navbar},
        data() {
            return {
                desktop: false,
            };
        },
        mounted() {
            this.init();
        },
        methods: {
            ...mapMutations(['setDesktop']),
            init() {
                this.setDesktop(screen.width >= 760);
                let logged = (this.$store.state.token !== '');
                if (logged && this.$route.name === 'Login')
                    this.$router.push('/dashboard');
            } ,
        },
    }
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Nunito+Sans&display=swap');

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        width: 100vw;
        height: auto;
    }

    #nav {
        padding: 30px;

        a {
            font-weight: bold;
            color: #2c3e50;

            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }

    h1 {
      color: #111111;
      font: 32px Avenir, Helvetica, Arial, sans-serif;;
    }

    h2 {
      color: #353639;
      font: 22px Avenir, Helvetica, Arial, sans-serif;;
    }

    h3 {
      color: #353639;
      font: 17px Avenir, Helvetica, Arial, sans-serif;
    }

    h4 {
      color: #414348;
      font: 17px Avenir, Helvetica, Arial, sans-serif;;
    }

    * {
        font: 14px 'Nunito Sans', sans-serif;
        text-transform: none !important;
        color: #414348;
    }

    button {
      border: 1px solid #111111 !important;
      border-radius: 20px;
      font: 16px 'Nunito Sans', sans-serif;
      color: #111111 !important;
      padding: 1% 3%;
    }

    button:hover {
      border: 1px solid #111111 !important;
      background-color: #111111 !important;
      color: #ffffff !important;
    }

    .icon {
      color: #929292 !important;
      border: none !important;
    }

    .icon:hover {
      color: #929292 !important;
      background-color: rgba(85, 85, 85, 0) !important;
      border: none !important;
    }
</style>
